import config from "../../../../packages/config"

export const frontmatter = {
  title: "Delete your account",
  description: `How to delete your ${config.core.projectName} account, what is deleted after the 30 day restore window, what may stay for a while, and what to export first.`,
  date: "2026-10-23",
}

You can delete your {config.core.projectName} account and the data in it at any time. This page explains how, what happens, and what we cannot remove straight away.

### Before you delete

The Australian Taxation Office (ATO) requires you to keep business records, including your logbook, odometer readings, expenses and receipts, for 5 years. Deleting your account deletes those records from our servers. **Export your data first** if you still need it: on the web, sign in at <a href="/account">/account</a> and choose "Export all my data" (a zip file of your records).

If you pay for a plan, cancel it first on the web at <a href="/account">/account</a> so it does not renew. The iPhone and Android apps do not take payments, so there is nothing to cancel in your Apple or Google settings.

### How to delete your account

- **On the web:** sign in at <a href="/account">/account</a> with your email, type your account email and tick the box, then choose "Delete my account". You do not need the app installed.

### What happens next

- Your account is scheduled for deletion in 30 days, and you are signed out on all your devices straight away. We email you the date.
- During those 30 days you can change your mind: sign in again (in the app, or at <a href="/account">/account</a>) and choose "Restore my account". Nothing is lost.
- After the 30 days, the account is deleted by a job that runs once a day, so it can happen up to about a day later. This cannot be undone.

### What is deleted

When the 30 days end we delete:

- your trips, including their GPS tracks and raw location points
- your vehicles and odometer readings
- your receipts, the receipt images you uploaded, and the expenses and AI-read results linked to them
- your sync history and audit records
- your sign-in account and profile (your email address)

### What may stay for a short time

Some copies are outside our direct control and expire on their own schedule:

- **Database backups** kept by our hosting provider are deleted when they rotate out. Deleted data is not restored into the live service.
- **Short-lived operational logs** may mention your account identifier. We do not write your trips, locations or receipts into them, and they expire after a short time.
- **Email delivery logs** kept by our email provider hold your email address for a short time.

### Questions

If you cannot sign in to delete your account, email us at <a href={`mailto:${config.core.supportEmail}`}>{config.core.supportEmail}</a>.
